module.exports = __webpack_public_path__ + "img/Vectolabs Primelux.cad80ee4.png";